export const SUPER_ADMIN = "SUPER_ADMIN"
export const LOCAL_ADMIN = "LOCAL_ADMIN"
export const ORG_ADMIN = "ORG_ADMIN"
export const ADMIN = "ADMIN"
export const BUSINESS_ADMIN = "BUSINESS_ADMIN"
export const COMMUNICATOR = "COMMUNICATOR"
